/**
 * Parallax Effects using GSAP ScrollTrigger
 * Creates depth and scroll storytelling
 */

(function() {
  'use strict';

  // Wait for GSAP and ScrollTrigger to load
  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.warn('GSAP or ScrollTrigger not loaded');
      return;
    }

    // Register ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);

    // Respect reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      return;
    }

    initHeroParallax();
    initSectionParallax();
    initFadeInAnimations();
  }

  /**
   * Hero Parallax
   * Background moves slower, product image moves faster (creates depth)
   */
  function initHeroParallax() {
    const hero = document.querySelector('.hero');
    if (!hero) return;

    const heroBackground = hero.querySelector('.hero__background');
    const heroImage = hero.querySelector('.hero__product-image');

    // Background layer - moves slower (creates distance)
    if (heroBackground) {
      gsap.to(heroBackground, {
        scrollTrigger: {
          trigger: hero,
          start: 'top top',
          end: 'bottom top',
          scrub: true,
        },
        y: '30%', // Moves slower than scroll
        ease: 'none'
      });
    }

    // Product image - moves faster (pops forward)
    if (heroImage) {
      gsap.to(heroImage, {
        scrollTrigger: {
          trigger: hero,
          start: 'top top',
          end: 'bottom top',
          scrub: true,
        },
        y: '-20%', // Moves faster than scroll
        ease: 'none'
      });
    }
  }

  /**
   * Section Parallax
   * Adds subtle movement to section backgrounds
   */
  function initSectionParallax() {
    const sections = document.querySelectorAll('.final-cta, .problem-solution, .pricing');

    sections.forEach(section => {
      gsap.to(section, {
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1,
        },
        backgroundPosition: '50% 0%',
        ease: 'none'
      });
    });
  }

  /**
   * Enhanced Fade-In Animations
   * Staggered reveals with better timing
   */
  function initFadeInAnimations() {
    // Animate cards/items in groups
    const cardGroups = document.querySelectorAll('.testimonials__grid, .how-it-works__steps, .format-benefits__grid');

    cardGroups.forEach(group => {
      const items = group.querySelectorAll('.testimonial-card, .how-it-works__step, .format-benefit__item');

      if (items.length === 0) return;

      gsap.from(items, {
        scrollTrigger: {
          trigger: group,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
        opacity: 0,
        y: 30,
        duration: 0.6,
        stagger: 0.15,
        ease: 'power3.out'
      });
    });

    // Animate section headlines
    const headlines = document.querySelectorAll('h2, h3');
    headlines.forEach(headline => {
      gsap.from(headline, {
        scrollTrigger: {
          trigger: headline,
          start: 'top 85%',
          toggleActions: 'play none none none',
        },
        opacity: 0,
        y: 20,
        duration: 0.8,
        ease: 'power3.out'
      });
    });
  }

  // Wait for GSAP with proper detection (no arbitrary timeout)
  function waitForGSAP(callback, maxAttempts) {
    maxAttempts = maxAttempts || 50;
    var attempts = 0;
    function check() {
      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        callback();
      } else if (attempts < maxAttempts) {
        attempts++;
        requestAnimationFrame(check);
      }
    }
    check();
  }

  // Initialize when DOM is ready and GSAP is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      waitForGSAP(init);
    });
  } else {
    waitForGSAP(init);
  }

})();
